export default __webpack_public_path__ + "static/media/test-white.5a28785f.svg";